import React from 'react'
import PropTypes from 'prop-types'
import Star from 'hec/assets/icons/star'
import Quiz from 'hec/assets/icons/quiz'
import {cn} from '@/lib/utils'

const ModuleProgress = ({lessons, quiz}) => (
    <div className="flex items-center mb-[2.375rem]">
        {lessons?.map((lesson, i) => (
            <React.Fragment key={`lesson-${i}`}>
                <div
                    className={cn(
                        'flex justify-center items-center mr-1 lg:mr-0 lg:w-[3.125rem] lg:h-[3.125rem] lg:bg-primary lg:rounded-full',
                        !lesson.complete && 'opacity-40'
                    )}
                >
                    <Star className="text-primary w-6 h-[1.3125rem] lg:text-primary-foreground" />
                </div>
                <div
                    className={cn(
                        'hidden lg:block mx-3 grow h-0.5 bg-primary',
                        !lesson.complete && 'opacity-40'
                    )}
                ></div>
            </React.Fragment>
        ))}
        {quiz && (
            <div
                className={cn(
                    'flex justify-center items-center lg:w-[3.125rem] lg:h-[3.125rem] lg:bg-primary lg:rounded-full',
                    !quiz.complete && 'opacity-40'
                )}
            >
                <Quiz className="text-primary w-6 h-[1.3125rem] lg:text-primary-foreground" />
            </div>
        )}
    </div>
)

ModuleProgress.propTypes = {
    lessons: PropTypes.array.isRequired,
    quiz: PropTypes.object.isRequired
}

export default ModuleProgress
